import { Component, Vue, Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';

import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import PopupController from '@/assets/ts/controller/PopupController';
import DetalhesRegistroOfflinePopup from '@/components/DetalhesRegistroOfflinePopup/DetalhesRegistroOfflinePopup.vue';
import MarcacaoRepository from '@/assets/ts/offline/repository/MarcacaoRepository';
import OfflineController from '@/assets/ts/controller/OfflineController';
import SincronizacaoController from '@/assets/ts/controller/SincronizacaoController';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';


@Component({
  name: 'OcorrenciasPontoOffline',
  components: {
    EditableTable,
    DetalhesRegistroOfflinePopup
  },
})
class OcorrenciasPontoOffline extends Vue {
  // #region [ STORE ]
  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get reloadCache(): number {
    return this.$store.getters.offline.reloadCache;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;
  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Ocorrências de Ponto Offline';

  private OfflineController = new OfflineController();

  private marcacoesOffline: any[] = [];

  private loading = false;

  private gridSelected = [];

  private isOpenModalDetalhesRegistro = false;

  private registroPopup = {
    open: false,
    isEdit: false
  };

  private toolbarAdditionalActions = [];

  private rowSelected: any[] = [];

  private messages = {
    onlineRequiredAction: 'É necessário estar conectado à internet para proseguir com esta ação!',
    erroGetMarcacoes: 'Não foi possível buscar as Marcações de Ponto Offline',
    erroDeleteMarcacao: 'Não foi possível excluir essa marcação!',
    onlineRequiredScreen: 'É necessário estar conectado à internet para acessar essa tela!'
  }

  private actions = [
    {
      label: 'Detalhes',
      value: 'detalhes',
      icon: 'mdi-eye',
      onClick: this.openDetailsOnClick,
      mode: 'view',
    },
    {
      label: 'Editar',
      value: 'editar',
      icon: 'mdi-pencil',
      onClick: this.openEditOnClick,
      mode: 'view',
      condition: this.visibleConditionEditRegistro,
    },
    {
      label: 'Excluir',
      value: 'excluir',
      icon: 'mdi-delete',
      onClick: this.openDeleteOnClick,
      mode: 'view',
      condition: this.visibleConditionDeleteRegistro,
    },
  ];

  private columns: EditableTableColumn[] = [
    {
      text: 'Nr. Vínculo / CPF',
      value: 'NRCHAVEVINCULO',
      type: 'text',
      textAlign: 'center'
    },
    {
      text: 'Nome',
      value: 'NMVINCULOM',
      type: 'text',
    },
    {
      text: 'Data Marcação',
      value: 'DTHRMARCACAOPONTO',
      type: 'date',
    },
    {
      text: 'Status',
      value: 'DSSINCRONIZADO',
      type: 'text',
    },
    {
      text: 'Observação de Erro',
      value: 'DSERROMARCACAO',
      type: 'text',
    },
  ];

  private toolbarActions: ToolbarAction[] = [
    {
      name: 'reload',
      label: 'Atualizar',
      showLabel: true,
      icon: 'mdi-refresh',
      onClick: this.reload,
    },
    {
      name: 'sincronizar',
      label: 'Sincronizar',
      showLabel: true,
      icon: 'mdi-cloud-sync-outline',
      onClick: this.sincronizarMarcacoes,
    },
  ];
  // #endregion

  // #region [ COMPUTED ]
  private get filtersAreSelected(): boolean {
    const areSelected =
      !Util.isUndefinedOrNull(this.estruturaGerencialAtual) &&
      !Util.isUndefinedOrNull(this.periodoDemonstrativoAtual);

    return areSelected;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private async created() {
    this.changeCurrentView(this.viewTitle);
    (window as any).marcacoesOffline = this;
  }

  private mounted() {
    this.reload();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaOnChange() {
    this.reload();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoOnChange() {
    this.reload();
  }

  @Watch('reloadCache', { immediate: true })
  private cacheOnChange() {
    this.reload();
  }
  // #endregion

  // #region [ METHODS ]
  private async reload() {
    this.loading = true;
    this.marcacoesOffline = [];

    try {
      const marcacoesOffline = await MarcacaoRepository.getMarcacoes();

      this.marcacoesOffline = marcacoesOffline;
    } catch (err) {
      SnackbarUtils.showMessage(this.messages.erroGetMarcacoes, SnackbarUtils.TYPE_ERROR);
    } finally {
      this.loading = false;
    }
  }
  
  private editRegistroAfterSave() {
    this.reload();
  }

  private visibleConditionEditRegistro(row: { IDSINCRONIZADO: string }) {
    return row.IDSINCRONIZADO === 'N';
  }

  private visibleConditionDeleteRegistro(row: { IDSINCRONIZADO: string }) {
    return row.IDSINCRONIZADO === 'N'
  }

  private openEditOnClick(row: any) {
    if(OfflineController.checkIsOffline()) {
      SnackbarUtils.showMessage(this.messages.onlineRequiredAction, SnackbarUtils.TYPE_ALERT);
      return;
    }

    this.rowSelected = row;
    this.registroPopup = { open: true, isEdit: true };
  }

  private async openDeleteOnClick(row: any) {
    if(OfflineController.checkIsOffline()) {
      SnackbarUtils.showMessage(this.messages.onlineRequiredAction, SnackbarUtils.TYPE_ALERT);
      return;
    }

    this.rowSelected = row;
    const nrMarcacaoOffline = row.NRMARCACAOOFFLINE;

    await DialogUtils.show(
      'Excluir Marcação com Erro',
      'Você realmente deseja excluir esta marcação?',
      async () => await this.deleteMarcacao(nrMarcacaoOffline),
      () => null
    );    

  }

  private openDetailsOnClick(row: any) {
    this.rowSelected = row;
    this.registroPopup = { open: true, isEdit: false };
  }

  private async deleteMarcacao(NRMARCACAOOFFLINE: string) {
    try {
      await MarcacaoRepository.deleteMarcacaoById(NRMARCACAOOFFLINE);
      this.reload();
    } catch (error) {
      SnackbarUtils.showMessage(this.messages.erroDeleteMarcacao, SnackbarUtils.TYPE_ERROR);
    }
  }

  private sincronizarMarcacoes() {
    SincronizacaoController.iniciarFluxoOnline(true);
  }

}

export default OcorrenciasPontoOffline;